import React, { useState, useEffect } from 'react';
import { Container, Card, Table, Button, Row, Col, Form, InputGroup, Badge, Pagination } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { FaEdit, FaTrash, FaPlus, FaSearch, FaTimes, FaSort, FaSortUp, FaSortDown, FaMapMarkerAlt, FaPhone } from 'react-icons/fa';
import Header from '~/Components/Header/Header';
import Loading from '~/Components/Loading';
import ModalConfirmacao from '~/Components/ModalConfirmacao';
import * as api from '~/Services/Service';
import ModalPdv from './ModalPdv';
import ModalEmpreendimentosPdv from './ModalEmpreendimentosPdv';

var ITENS_POR_PAGINA = 20;

var CadastroPdv = function () {
  var [pdvs, setPdvs] = useState([]);
  var [loading, setLoading] = useState(true);
  var [filtro, setFiltro] = useState('');
  var [ordenacao, setOrdenacao] = useState({ campo: 'descricao', direcao: 'asc' });
  var [pagina, setPagina] = useState(1);
  var [modalAberto, setModalAberto] = useState(false);
  var [pdvSelecionado, setPdvSelecionado] = useState(null);
  var [confirmacao, setConfirmacao] = useState({ show: false, item: null });
  var [modalEmpAberto, setModalEmpAberto] = useState(false);
  var [pdvEmpreendimentos, setPdvEmpreendimentos] = useState(null);

  useEffect(function () {
    carregarPdvs();
  }, []);

  var carregarPdvs = async function (silencioso) {
    if (!silencioso) setLoading(true);
    try {
      var resp = await api.listarPdvs();
      setPdvs(resp || []);
    } catch (e) {
      toast.error('Erro ao carregar PDVs.');
    } finally {
      if (!silencioso) setLoading(false);
    }
  };

  var handleOrdenacao = function (campo) {
    setOrdenacao(function (prev) {
      if (prev.campo === campo) {
        return { campo: campo, direcao: prev.direcao === 'asc' ? 'desc' : 'asc' };
      }
      return { campo: campo, direcao: 'asc' };
    });
  };

  var iconeOrdenacao = function (campo) {
    if (ordenacao.campo !== campo) return <FaSort style={{ opacity: 0.3, marginLeft: 4 }} />;
    return ordenacao.direcao === 'asc'
      ? <FaSortUp style={{ marginLeft: 4 }} />
      : <FaSortDown style={{ marginLeft: 4 }} />;
  };

  var thSortStyle = { cursor: 'pointer', userSelect: 'none', whiteSpace: 'nowrap' };

  var pdvsFiltrados = pdvs
    .filter(function (p) {
      if (!filtro) return true;
      var termo = filtro.toLowerCase();
      return (p.descricao || '').toLowerCase().indexOf(termo) >= 0
        || (p.endereco || '').toLowerCase().indexOf(termo) >= 0
        || (p.bairro || '').toLowerCase().indexOf(termo) >= 0
        || (p.descricao_cidade || '').toLowerCase().indexOf(termo) >= 0;
    })
    .slice()
    .sort(function (a, b) {
      var campo = ordenacao.campo;
      var dir = ordenacao.direcao === 'asc' ? 1 : -1;
      var valA = a[campo]; var valB = b[campo];
      if (valA == null) valA = '';
      if (valB == null) valB = '';
      if (typeof valA === 'string') {
        return dir * valA.toLowerCase().localeCompare(String(valB).toLowerCase());
      }
      return dir * (valA - valB);
    });

  var totalPaginas = Math.ceil(pdvsFiltrados.length / ITENS_POR_PAGINA) || 1;
  var dadosPaginados = pdvsFiltrados.slice((pagina - 1) * ITENS_POR_PAGINA, pagina * ITENS_POR_PAGINA);

  var renderizarPaginacao = function () {
    if (totalPaginas <= 1) return null;

    var itens = [];
    var maxBotoes = 5;

    itens.push(
      <Pagination.First
        key="first"
        onClick={function () { setPagina(1); }}
        disabled={pagina === 1}
      />
    );

    itens.push(
      <Pagination.Prev
        key="prev"
        onClick={function () { setPagina(pagina - 1); }}
        disabled={pagina === 1}
      />
    );

    var inicioPaginas = Math.max(1, pagina - Math.floor(maxBotoes / 2));
    var fimPaginas = Math.min(totalPaginas, inicioPaginas + maxBotoes - 1);

    if (fimPaginas - inicioPaginas < maxBotoes - 1) {
      inicioPaginas = Math.max(1, fimPaginas - maxBotoes + 1);
    }

    if (inicioPaginas > 1) {
      itens.push(<Pagination.Ellipsis key="ellipsis-start" disabled />);
    }

    var numeros = [];
    for (var i = inicioPaginas; i <= fimPaginas; i++) { numeros.push(i); }
    numeros.forEach(function (num) {
      itens.push(
        <Pagination.Item
          key={num}
          active={num === pagina}
          onClick={function () { setPagina(num); }}
        >
          {num}
        </Pagination.Item>
      );
    });

    if (fimPaginas < totalPaginas) {
      itens.push(<Pagination.Ellipsis key="ellipsis-end" disabled />);
    }

    itens.push(
      <Pagination.Next
        key="next"
        onClick={function () { setPagina(pagina + 1); }}
        disabled={pagina === totalPaginas}
      />
    );

    itens.push(
      <Pagination.Last
        key="last"
        onClick={function () { setPagina(totalPaginas); }}
        disabled={pagina === totalPaginas}
      />
    );

    return (
      <div className="d-flex justify-content-between align-items-center px-3 py-2" style={{ borderTop: '1px solid #dee2e6' }}>
        <small className="text-muted">
          Mostrando {dadosPaginados.length > 0 ? (pagina - 1) * ITENS_POR_PAGINA + 1 : 0}
          {' até '}{Math.min(pagina * ITENS_POR_PAGINA, pdvsFiltrados.length)}{' de '}{pdvsFiltrados.length}{' registros'}
        </small>
        <Pagination className="mb-0">{itens}</Pagination>
      </div>
    );
  };

  var handleNovoClick = function () {
    setPdvSelecionado(null);
    setModalAberto(true);
  };

  var handleEditarClick = function (item) {
    setPdvSelecionado(item);
    setModalAberto(true);
  };

  var handleExcluirClick = function (item) {
    setConfirmacao({ show: true, item: item });
  };

  var handleConfirmarExclusao = async function (confirmado) {
    if (!confirmado) {
      setConfirmacao({ show: false, item: null });
      return;
    }
    var item = confirmacao.item;
    setConfirmacao({ show: false, item: null });
    try {
      await api.excluirPdv({ codigo_pdv: item.codigo_pdv });
      toast.success('PDV excluído com sucesso.');
      carregarPdvs();
    } catch (err) {
      toast.error((err && err.message) || 'Erro ao excluir PDV.');
    }
  };

  var handleSalvar = function () {
    setModalAberto(false);
    carregarPdvs();
  };

  var handleAbrirEmpreendimentos = function (item) {
    setPdvEmpreendimentos(item);
    setModalEmpAberto(true);
  };

  var linkStyle = { cursor: 'pointer', color: '#0747a6', textDecoration: 'underline', fontWeight: 'bold' };

  var montarEndereco = function (item) {
    return [item.endereco, item.numero ? 'nº ' + item.numero : null, item.bairro].filter(Boolean).join(', ');
  };

  var itemConfirmacao = confirmacao.item;

  if (loading) return <Loading />;

  return (
    <Container fluid className="px-3 py-3">
      <style>{'\
        .pdv-desktop { display: block; }\
        .pdv-mobile  { display: none; }\
        @media (max-width: 768px) {\
          .pdv-desktop { display: none !important; }\
          .pdv-mobile  { display: block; }\
          .pdv-filtro-row { flex-direction: column; }\
          .pdv-filtro-row .text-right { text-align: right !important; margin-top: 8px; }\
        }\
      '}</style>

      <Header title="Cadastro de PDV" />

      <Card className="shadow-sm mb-3">
        <Card.Body>
          <Row className="align-items-end">
            <Col xs={12} md={5}>
              <Form.Group controlId="filtro.busca" className="mb-md-0 mb-2">
                <Form.Label>Busca</Form.Label>
                <InputGroup>
                  <InputGroup.Prepend>
                    <InputGroup.Text><FaSearch /></InputGroup.Text>
                  </InputGroup.Prepend>
                  <Form.Control
                    type="text"
                    placeholder="Descrição, endereço, bairro ou cidade..."
                    value={filtro}
                    onChange={function (e) { setFiltro(e.target.value); setPagina(1); }}
                  />
                </InputGroup>
              </Form.Group>
            </Col>
            <Col xs={12} md={7}>
              <Form.Group className="d-flex justify-content-end flex-wrap mb-0" style={{ gap: '8px' }}>
                {filtro && (
                  <Button variant="outline-secondary" onClick={function () { setFiltro(''); setPagina(1); }}>
                    <FaTimes className="mr-1" /> Limpar
                  </Button>
                )}
                <Button variant="success" onClick={handleNovoClick}>
                  <FaPlus className="mr-1" /> Novo PDV
                </Button>
              </Form.Group>
            </Col>
          </Row>
        </Card.Body>
      </Card>

      <Card className="shadow-sm">
        <Card.Header
          className="d-flex justify-content-between align-items-center py-2"
          style={{ backgroundColor: '#0747a6', color: '#fff' }}
        >
          <strong>
            PDVs Cadastrados
            <span className="ml-2" style={{ fontSize: '0.85rem', opacity: 0.8 }}>
              ({pdvsFiltrados.length} {pdvsFiltrados.length === 1 ? 'registro' : 'registros'})
            </span>
          </strong>
        </Card.Header>
        <Card.Body className="p-0">
          {pdvsFiltrados.length === 0 ? (
            <p className="text-muted text-center my-4">
              {filtro ? 'Nenhum PDV encontrado para "' + filtro + '".' : 'Nenhum PDV cadastrado.'}
            </p>
          ) : (
            <>
              <div className="pdv-desktop">
                <Table striped bordered hover size="sm" className="mb-0">
                  <thead>
                    <tr>
                      <th style={Object.assign({ width: '80px' }, thSortStyle)} onClick={function () { handleOrdenacao('codigo_pdv'); }}>Código{iconeOrdenacao('codigo_pdv')}</th>
                      <th style={thSortStyle} onClick={function () { handleOrdenacao('descricao'); }}>Descrição{iconeOrdenacao('descricao')}</th>
                      <th style={thSortStyle} onClick={function () { handleOrdenacao('endereco'); }}>Endereço{iconeOrdenacao('endereco')}</th>
                      <th style={Object.assign({ width: '70px' }, thSortStyle)} onClick={function () { handleOrdenacao('numero'); }}>Nº{iconeOrdenacao('numero')}</th>
                      <th style={thSortStyle} onClick={function () { handleOrdenacao('bairro'); }}>Bairro{iconeOrdenacao('bairro')}</th>
                      <th style={thSortStyle} onClick={function () { handleOrdenacao('descricao_cidade'); }}>Cidade{iconeOrdenacao('descricao_cidade')}</th>
                      <th style={Object.assign({ width: '50px' }, thSortStyle)} onClick={function () { handleOrdenacao('estado'); }}>UF{iconeOrdenacao('estado')}</th>
                      <th style={Object.assign({ width: '100px' }, thSortStyle)} onClick={function () { handleOrdenacao('telefone'); }}>Telefone{iconeOrdenacao('telefone')}</th>
                      <th style={Object.assign({ width: '80px', textAlign: 'center' }, thSortStyle)} onClick={function () { handleOrdenacao('qtd_empreendimentos'); }}>Empr.{iconeOrdenacao('qtd_empreendimentos')}</th>
                      <th style={{ width: '90px', textAlign: 'center' }}>Ações</th>
                    </tr>
                  </thead>
                  <tbody>
                    {dadosPaginados.map(function (item) {
                      return (
                        <tr key={item.codigo_pdv}>
                          <td>{item.codigo_pdv}</td>
                          <td><strong>{item.descricao}</strong></td>
                          <td>{item.endereco}</td>
                          <td>{item.numero}</td>
                          <td>{item.bairro}</td>
                          <td>{item.descricao_cidade}</td>
                          <td className="text-center">{item.estado}</td>
                          <td>{item.telefone}</td>
                          <td className="text-center">
                            <span style={linkStyle} onClick={function () { handleAbrirEmpreendimentos(item); }}>
                              {item.qtd_empreendimentos != null ? item.qtd_empreendimentos : 0}
                            </span>
                          </td>
                          <td className="text-center" style={{ whiteSpace: 'nowrap' }}>
                            <Button
                              size="sm"
                              variant="outline-primary"
                              title="Editar"
                              className="mr-1"
                              onClick={function () { handleEditarClick(item); }}
                            >
                              <FaEdit />
                            </Button>
                            <Button
                              size="sm"
                              variant="outline-danger"
                              title="Excluir"
                              onClick={function () { handleExcluirClick(item); }}
                            >
                              <FaTrash />
                            </Button>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              </div>

              <div className="pdv-mobile p-2">
                {dadosPaginados.map(function (item) {
                  var endereco = montarEndereco(item);
                  return (
                    <Card key={item.codigo_pdv} className="mb-2 shadow-sm">
                      <Card.Body className="py-2 px-3">
                        <div className="d-flex justify-content-between align-items-start">
                          <div>
                            <strong style={{ fontSize: '0.95rem' }}>{item.descricao}</strong>
                            <br />
                            <small className="text-muted">Código: {item.codigo_pdv}</small>
                          </div>
                          {item.estado && (
                            <Badge variant="info">{item.descricao_cidade ? item.descricao_cidade + '/' + item.estado : item.estado}</Badge>
                          )}
                        </div>
                        {endereco && (
                          <div className="mt-1" style={{ fontSize: '0.85rem', color: '#555' }}>
                            <FaMapMarkerAlt style={{ marginRight: 4, opacity: 0.6 }} />
                            {endereco}
                          </div>
                        )}
                        {item.telefone ? (
                          <div className="mt-1" style={{ fontSize: '0.85rem', color: '#555' }}>
                            <FaPhone style={{ marginRight: 4, opacity: 0.6 }} />
                            {item.telefone}
                          </div>
                        ) : null}
                        <div className="mt-2 d-flex justify-content-between align-items-center">
                          <span style={linkStyle} onClick={function () { handleAbrirEmpreendimentos(item); }}>
                            <Badge variant="secondary" className="mr-1">{item.qtd_empreendimentos != null ? item.qtd_empreendimentos : 0}</Badge>
                            empreendimentos
                          </span>
                          <div className="d-flex" style={{ gap: '8px' }}>
                            <Button size="sm" variant="outline-primary" onClick={function () { handleEditarClick(item); }}>
                              <FaEdit className="mr-1" /> Editar
                            </Button>
                            <Button size="sm" variant="outline-danger" onClick={function () { handleExcluirClick(item); }}>
                              <FaTrash className="mr-1" /> Excluir
                            </Button>
                          </div>
                        </div>
                      </Card.Body>
                    </Card>
                  );
                })}
              </div>
              {renderizarPaginacao()}
            </>
          )}
        </Card.Body>
      </Card>

      <ModalPdv
        show={modalAberto}
        onHide={function () { setModalAberto(false); }}
        pdv={pdvSelecionado}
        onSalvar={handleSalvar}
      />

      <ModalEmpreendimentosPdv
        show={modalEmpAberto}
        onHide={function () { setModalEmpAberto(false); }}
        pdv={pdvEmpreendimentos}
        onAlterou={function () { carregarPdvs(true); }}
      />

      <ModalConfirmacao
        show={confirmacao.show}
        title="Confirmar Exclusão"
        message={
          itemConfirmacao
            ? 'Deseja excluir o PDV \'' + (itemConfirmacao.descricao || '') + '\'?'
            : ''
        }
        onClose={handleConfirmarExclusao}
      />
    </Container>
  );
};

export default CadastroPdv;
